export default "__VITE_ASSET__Boex3bt1__"